import { initializeApp } from 'firebase/app';
import { getMessaging, getToken } from 'firebase/messaging';
//import { MessagePayload, deleteToken, getMessaging, getToken, onMessage } from 'firebase/messaging';
const vapidKey = 'BNsaLlOfs0X9Nwn0TGGgYwO6Xdb5XTDfVZkWtdnBsRMXqQ0UgMfmLJ4bmImcg6f3TQsPxTONwLWD9yBK-QKvAB0';
const app = initializeApp({
  apiKey: "AIzaSyBzuVstdmCb-42wMqCdoxmwWJZeW2yLbBY",
  authDomain: "clustertradeweb.firebaseapp.com",
  projectId: "clustertradeweb",
  storageBucket: "clustertradeweb.firebasestorage.app",
  messagingSenderId: "93845003828",
  appId: "1:93845003828:web:f21a110695a8352aad7461",
  measurementId: "G-6NGV7S6PZ8"
});
const messaging = getMessaging(app);

export const requestNotificationPermission = async function requestNotificationPermission() {
  try {
    if ('serviceWorker' in navigator) {
      const registration = await navigator.serviceWorker.register('/firebase-messaging-sw.js', {
        scope: '/'
      });
      // Handle background messages from service worker


      console.log('Service Worker registered with scope:', registration.scope);
      const permission = await Notification.requestPermission();
      if (permission === 'granted') {
        console.log('Notification permission granted.');
        return await getToken(messaging, { vapidKey });
      } else {
        console.log('Unable to get permission to notify.');
        return null;
      }
    }
  } catch (error) {
    console.error('Error requesting notification permission:', error);
    return null;
  }
}





